<template>
  <custom-callout
    :border-color="getColorStatus(value.status)"
    class="mb-3 callout"
    :has-toggle="false"
    :opened="isOpen"
  >
    <div class="row mt-2 row-container">
      <div class="col-md-1 col-12 border-right status">
        <div class="row align-items-center">
          <div class="col-12 d-none d-md-block">
            <div class="label">Año Fiscal:</div>
            <span class="info">
              {{ value.academicYear }}
            </span>
          </div>
          <div class="col-7 col-md-12 mt-md-4">
            <custom-balloon
              :background-color="` bg-${getColorStatus(value.status)}`"
              class="w-md-90 w-100 m-0"
              :text="value.status.name"
            />
          </div>
          <div class="col-12 d-none d-md-block mt-md-4">
            <div class="label">Tipo de Ajuste:</div>
            <span class="info">
              {{ value.adjustmentType }}
            </span>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-11">
        <div class="row">
          <div class="col-12 col-md-4 mt-4 mt-md-0">
            <div class="label">Nombre:</div>
            <span class="info">
              {{ value.name }}
            </span>
          </div>
          <div class="col-12 col-md-3 mt-4 mt-md-0">
            <div class="label">Monto:</div>
            <span class="info">${{ value.amount | currency }}</span>
          </div>
          <div class="col-12 col-md-3 mt-4 mt-md-0">
            <div class="label">Cantidad de Excepciones:</div>
            <span class="info">
              {{ value.exceptions }}
            </span>
          </div>
          <div
            class="col-12 col-md-2 mt-4 mt-md-0 d-none d-md-flex align-items-start"
          >
            <dropdown
              class="actions-dropdown"
              :data-item="{ value, index }"
              :items="actionItems"
              title="Acciones"
            />
          </div>
          <div class="col-12 mt-4 mb-2">
            <div class="label">Descripción:</div>
            <span class="info">
              {{ value.description }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomBalloon from 'custom-balloon';
import Dropdown from 'dropdown';
import { Colors } from '@/components/common';
import CustomCallout from 'custom-callout';
import alertMixin from 'utils/mixins/alert.mixin.js';

export default {
  name: 'RowStandard',
  components: {
    CustomBalloon,
    Dropdown,
    CustomCallout,
  },
  mixins: [alertMixin],
  props: {
    colorBallon: {
      type: String,
      default: () => 'gray',
    },
    value: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    accessType: {
      type: String,
      default: () => 'NoAccess',
    },
  },
  data: () => ({
    isOpen: false,
  }),
  computed: {
    actionItems() {
      let actions = [
        {
          name: 'details',
          label: 'Entrar',
          icon: 'fas fa-flag text-green pr-1',
          visible: true,
        },
        {
          name: 'edit',
          label: 'Editar',
          icon: 'fas fa-edit text-green pr-1',
          visible: true,
        },
      ];
      return actions;
    },
  },
  methods: {
    getColorStatus(status) {
      let color = Colors.GREEN_LIGHT;

      if (status.id === '1') {
        color = 'brown';
      }

      return color;
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

.label {
  font-weight: normal;
  font-size: 0.875rem;
  color: map-get($colors, 'secondary-6');
}

.info {
  font-weight: normal;
  color: map-get($colors, 'black');
}

.evaluator_status {
  color: map-get($colors, 'black');
  font-weight: normal;

  &__fullname {
    font-size: 1rem;
  }

  &__pill {
    width: 100px;
    font-size: 0.75rem;
    display: inline;
    margin-left: 0.5em;
  }
}

@media only screen and (max-width: 768px) {
  .actions-dropdown {
    ::v-deep {
      .dropdown-toggle {
        width: 100%;
        font-size: 0.875rem;
      }
    }
  }
}
</style>
